import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { registerCharts } from 'components/Analytics/ChartConfig';
import { FinancialOverview } from './FinancialOverview';
import { TopUpBalance } from './TopUpBalance';
import { ViewType } from './shared/types';
import {WithdrawFunds} from "components/Finance/WithdrawFunds";

registerCharts();

export const Finance = () => {
    const [currentView, setCurrentView] = useState<ViewType>('overview');
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [filterDate, setFilterDate] = useState<Date[]>([]);

    const handleViewChange = (view: ViewType) => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentView(view);
            setIsTransitioning(false);
        }, 200);
    };

    const handleDateChange = (dates: Date[]) => {
        /**TODO: handle API data */
        setFilterDate(dates);
    };

    return (
        <Container>
            <ContentWrapper $isTransitioning={isTransitioning}>
                {currentView === 'overview' && (
                    <FinancialOverview
                        handleViewChange={handleViewChange}
                        filterDate={filterDate}
                        onDateChange={handleDateChange}
                    />
                )}
                {currentView === 'topup' && (
                    <TopUpBalance onBack={() => handleViewChange('overview')} />
                )}
                {currentView === 'withdraw' && (
                    <WithdrawFunds onBack={() => handleViewChange('overview')} />
                )}
            </ContentWrapper>
        </Container>
    );
};

const fadeOut = keyframes`
    from {
        opacity: 1;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        transform: translateY(-10px);
    }
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Container = styled.div`
    background: #fff;
`;

const ContentWrapper = styled.div<{ $isTransitioning: boolean }>`
    animation: ${props => props.$isTransitioning ? fadeOut : fadeIn} 0.3s ease-in-out;
`;

const Placeholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    font-size: 20px;
    color: #7B7B7B;

    @media (max-width: 768px) {
        min-height: 300px;
        font-size: 18px;
        padding: 20px;
        text-align: center;
    }

    @media (max-width: 480px) {
        font-size: 16px;
    }
`;